import { render } from "./TheTemplateDialog.vue?vue&type=template&id=6dca5a7b&ts=true"
import script from "./TheTemplateDialog.vue?vue&type=script&lang=ts"
export * from "./TheTemplateDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__